<template>
    <footer class="footer pt-md-5">
        <div class="container pt-3">
            <div class="row gy-3 position-relative pb-3">
                <div class="col-lg-3 col-sm-6 mb-4 mb-lg-0">
                    <div class="logo">
                        <router-link :to="{ path: `/${$i18n.locale}` }">
                            <img loading="lazy" src="../../assets/images/logo-old-dark.svg" alt="logo"
                                style="width: auto !important;" width="170" height="100" />
                        </router-link>
                        <p class="py-4 desc">
                            {{ $t('e_learning_description') }}
                        </p>
                        <!-----Start Of Social Links--------------->
                        <div class="d-flex d-lg-block align-items-center">
                            <div class="social">
                                <div class="gap-4 d-flex align-items-center ">
                                    <div class="ins" v-if="socialMediaLinks?.instagram">
                                        <a :href="socialMediaLinks.instagram" target="_blank" aria-label="instagram">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20"
                                                viewBox="0 0 22 20" fill="none">
                                                <path
                                                    d="M17.3259 0H20.6992L13.3293 8.47278L22 20H15.2112L9.8945 13.0079L3.80967 20H0.4345L8.31783 10.9372L0 0.000921999H6.96117L11.7673 6.39192L17.3259 0ZM16.1425 17.9699H18.0116L5.9455 1.92412H3.93983L16.1425 17.9699Z"
                                                    fill="white" />
                                            </svg>
                                        </a>
                                    </div>
                                    <div class="twitter" v-if="socialMediaLinks?.twitter">
                                        <a :href="socialMediaLinks.twitter" target="_blank" aria-label="twitter">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16Z"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M3 16V8C3 6.67392 3.52678 5.40215 4.46447 4.46447C5.40215 3.52678 6.67392 3 8 3H16C17.3261 3 18.5979 3.52678 19.5355 4.46447C20.4732 5.40215 21 6.67392 21 8V16C21 17.3261 20.4732 18.5979 19.5355 19.5355C18.5979 20.4732 17.3261 21 16 21H8C6.67392 21 5.40215 20.4732 4.46447 19.5355C3.52678 18.5979 3 17.3261 3 16Z"
                                                    stroke="white" stroke-width="1.5" />
                                                <path d="M17.5 6.511L17.51 6.5" stroke="white" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </a>
                                    </div>
                                    <div class="linkedin" v-if="socialMediaLinks?.linkedIn">
                                        <a :href="socialMediaLinks.linkedIn" target="_blank" aria-label="linked in">
                                            <i class="fa-brands fa-linkedin-in text-primary"></i>
                                        </a>
                                    </div>
                                    <div class="facebook" v-if="socialMediaLinks?.facebook">
                                        <a :href="socialMediaLinks.facebook" target="_blank" aria-label="facebook">
                                            <i class="fa-brands fa-facebook-f text-white fs-5"></i>
                                        </a>
                                    </div>
                                    <div class="whatsapp" v-if="socialMediaLinks?.whatsApp">
                                        <a :href="socialMediaLinks.whatsApp" target="_blank" aria-label="whatsapp">
                                            <i class="fa-brands fa-whatsapp text-white fs-4"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!----------end of Social Links--------->
                    </div>
                </div>
                <!----Start of navigation ------------>
                <div class="col-lg-2 col-sm-6">
                    <!-- <div class="row gx-lg-5 w-100">
                        <div class="col-md-6"> -->
                    <div class="whoWeAre">
                        <h3 class="h5"></h3>
                        <router-link :to="{ path: `/${$i18n.locale}` }" exact>
                            <p>
                                {{ $t("home") }}
                            </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/about` }" exact>
                            <p>
                                {{ $t("about_us") }}
                            </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/contact` }" exact>
                            <p>
                                {{ $t("contact_us") }}
                            </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/courses` }" exact>
                            <p>
                                {{ $t("courses") }}
                            </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/blog` }" exact>
                            <p>{{ $t('blogs') }}</p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/reviews` }" exact>
                            <p>
                                {{ $t("reviews") }}
                            </p>
                        </router-link>
                    </div>
                </div>
                <!-------------------2nd Navigation column------------>
                <div class="col-lg-2 col-sm-6">
                    <div class="whoWeAre">
                        <router-link :to="{ path: `/${$i18n.locale}/complains` }">
                            <p> {{ $t("suggestions_complaints") }} </p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/blog` }">
                            <p>{{ $t("blogs") }}</p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/partners` }" exact>
                            <p>{{ $t('partners') }}</p>
                        </router-link>
                        <!-- <router-link :to="{ path: `/${$i18n.locale}/faq` }">
                           <p> {{ $t("faq_title") }}</p>
                        </router-link> -->
                        <router-link :to="{ path: `/${$i18n.locale}/support` }">
                            <p>{{ $t("technical_support") }}</p>
                        </router-link>
                    </div>
                </div>
                <!-----Start of Course Navigation---------------->
                <div class="col-lg-2 col-sm-6">
                    <div class="whoWeAre">
                        <router-link :to="{ path: `/${$i18n.locale}/learning` }" exact>
                            <p>{{ $t("remote_learning") }}</p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/terms-conditions` }" exact>
                            <p>{{ $t("privacy_policy") }}</p>
                        </router-link>
                        <!-- <router-link :to="{ path: `/${$i18n.locale}/privacy-policy` }" exact>
                            <p>{{ $t("privacy_policy") }}</p>
                        </router-link> -->
                        <router-link :to="{ path: `/${$i18n.locale}/terms` }" exact>
                            <p>{{ $t("terms_conditions") }}</p>
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/faq` }" exact>
                            <p>{{ $t("faq_title") }}</p>
                        </router-link>
                    </div>
                </div>
                <!------End Of Course Navigation---------->
                <!-----Start Of Applications------------------>
                <div class="col-lg-3 col-md-12 d-flex d-lg-block flex-wrap align-items-center justify-content-center">
                    <div class="application">
                        <h4 class="h5">{{ $t('content.downloadApp') }}</h4>
                        <div class="apps py-3 d-flex align-items-center gap-3 flex-wrap justify-content-center">
                            <router-link class="apple flex-grow-1" role="button"
                                :to="{ path: `/${$i18n.locale}/app/ios` }">
                                <p class="app-text">App Store</p>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M19.1001 19.16C19.6901 18.26 19.9101 17.8 20.3601 16.79C17.0401 15.53 16.5101 10.8 19.7901 8.99C18.7901 7.73 17.3801 7 16.0501 7C15.0901 7 14.4301 7.25 13.8401 7.48C13.3401 7.67 12.8901 7.84 12.3301 7.84C11.7301 7.84 11.2001 7.65 10.6401 7.45C10.0301 7.23 9.39007 7 8.59007 7C7.10007 7 5.51007 7.91 4.50007 9.47C3.08007 11.67 3.33007 15.79 5.62007 19.31C6.44007 20.57 7.54007 21.98 8.97007 22C9.57007 22.01 9.96007 21.83 10.3901 21.64C10.8801 21.42 11.4101 21.18 12.3401 21.18C13.2701 21.17 13.7901 21.42 14.2801 21.64C14.7001 21.83 15.0801 22.01 15.6701 22C17.1201 21.98 18.2801 20.42 19.1001 19.16ZM15.8401 2C16.0001 3.1 15.5501 4.19 14.9601 4.95C14.3301 5.77 13.2301 6.41 12.1701 6.37C11.9801 5.31 12.4701 4.22 13.0701 3.49C13.7401 2.69 14.8701 2.07 15.8401 2Z"
                                        fill="white" />
                                </svg>
                            </router-link>
                            <router-link class="googlePlay flex-grow-1" role="button"
                                :to="{ path: `/${$i18n.locale}/app/android` }">
                                <p class="app-text">Google Play</p>
                                <svg width="24" height="24" viewBox="0 0 21 18" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.6829 9.97253L16.8624 11.3625C16.6696 11.4625 16.4363 11.4225 16.2739 11.2725L14.3767 9.40253C14.1737 9.20253 14.1737 8.89253 14.3767 8.69253L16.3044 6.79253C16.4566 6.64253 16.7001 6.60253 16.8928 6.70253L19.6829 8.08253C20.4844 8.46253 20.4844 9.58253 19.6829 9.97253ZM14.5086 5.51353C14.8231 5.66353 14.8839 6.07353 14.6404 6.31353L12.9461 7.98353L12.2257 8.69353C12.0228 8.89353 11.7083 8.89353 11.5054 8.69353L4.26126 1.55453C3.85644 1.15453 4.33228 0.504531 4.84972 0.754531L14.5086 5.51353ZM1.17659e-05 17.1725V0.502531C1.17659e-05 0.0625312 0.537741 -0.167469 0.862408 0.142531L9.7603 8.65253C9.97337 8.85253 9.96322 9.18253 9.75016 9.38253L0.852262 17.5425C0.779674 17.6089 0.688973 17.6529 0.591338 17.669C0.493704 17.6852 0.393403 17.6728 0.302801 17.6335C0.212198 17.5942 0.135253 17.5296 0.0814498 17.4477C0.0276468 17.3657 -0.000662382 17.2701 1.17659e-05 17.1725ZM14.4781 12.5415L4.95118 17.2415C4.43374 17.4915 3.95689 16.8415 4.36272 16.4415L11.5155 9.39153C11.7184 9.19153 12.033 9.19153 12.2359 9.39153L14.6202 11.7415C14.8535 11.9815 14.7825 12.3915 14.4781 12.5415Z"
                                        fill="white" />
                                </svg>
                            </router-link>
                        </div>
                        <div class="cards flex-wrap">
                            <div class="img-bg mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/PayPal.webp" alt="paypal logo"
                                    width="53" height="53" />
                            </div>
                            <div class="img-bg-1 mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/Mastercard.webp"
                                    alt="master logo" width="95" height="78" class="img-1" />
                            </div>
                            <div class="img-bg-1 mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/Visa.webp" alt="Visa logo"
                                    width="95" height="78" class="img-2" />
                            </div>
                            <div class="img-bg mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/mada.webp" alt="Mada logo"
                                    width="53" height="53" />
                            </div>
                            <div class="img-bg mt-1">
                                <img loading="lazy" src="../../assets/images/layout/cards/Pay.webp" alt="Pay logo"
                                    width="53" height="53" />
                            </div>
                        </div>
                    </div>
                </div>
                <!--end of applications----------------->
            </div>
            <!------start Of Copy right---------------->
            <hr />
            <div class="d-flex justify-content-between gap-3  footer-rights  align-items-center flex-wrap">
                <div id="footer-desc">
                    <p>{{ $t("footer_rights_reserved") }}</p>
                </div>

                <div id="rights" class="d-flex align-items-center gap-3 flex-wrap align-self-end">
                    <router-link :to="{ path: `/${$i18n.locale}/terms-conditions` }">
                        <p>{{ $t("privacy_policy") }}</p>
                    </router-link>
                    <router-link :to="{ path: `/${$i18n.locale}/learning` }">
                        {{ $t("remote_learning") }}
                    </router-link>
                    <!-- <router-link :to="{ path: `/${$i18n.locale}/terms-conditions` }">
                            {{ $t('property-rights-protection') }}
                        </router-link> -->
                    <router-link :to="{ path: `/${$i18n.locale}/terms` }">
                        {{ $t("terms_conditions") }}
                    </router-link>
                    <router-link :to="{ path: `/${$i18n.locale}/attendance-policy` }">
                        {{ $t("attendance-policy") }}
                    </router-link>
                    <router-link :to="{ path: `/${$i18n.locale}/communication-policy` }">
                        {{ $t("communication-policy") }}
                    </router-link>
                    <!-- <router-link :to="{ path: `/${$i18n.locale}/faq` }">
                            {{ $t("faq_title") }}
                        </router-link>
                        <router-link :to="{ path: `/${$i18n.locale}/support` }">
                             {{ $t("technical_support") }}
                        </router-link> -->
                    <!-- <p class="pt-2">{{ $t("footer_supported_by") }}</p> -->
                </div>
            </div>
            <!-------------------------->
        </div>
    </footer>
</template>
<script>
import { getPageByCode } from "@/Services/api/PagesService";
import PagesCodes from "@/constants/PagesCode";

export default {
    name: "FooterItem",
    data() {
        return {
            socialMediaLinks: null,
        };
    },
    methods: {
        async fetchSocialLinks() {
            try {
                const response = await getPageByCode(PagesCodes.ContactUs);
                if (response && response.data) {
                    this.socialMediaLinks = response.data.socialMediaLinks;
                    console.log("Social Media Links:", this.socialMediaLinks);
                    if (!this.socialMediaLinks.instagram.startsWith("http")) {
                        this.socialMediaLinks.instagram = "https://" + this.socialMediaLinks.instagram;
                    }
                    if (!this.socialMediaLinks.twitter.startsWith("http")) {
                        this.socialMediaLinks.twitter = "https://" + this.socialMediaLinks.twitter;
                    }
                    if (!this.socialMediaLinks.linkedIn.startsWith("http")) {
                        this.socialMediaLinks.linkedIn = "https://" + this.socialMediaLinks.linkedIn;
                    }
                    if (!this.socialMediaLinks.facebook.startsWith("http")) {
                        this.socialMediaLinks.facebook = "https://" + this.socialMediaLinks.facebook;
                    }
                    if (!this.socialMediaLinks.whatsApp.startsWith("http")) {
                        this.socialMediaLinks.whatsApp = "https://" + this.socialMediaLinks.whatsApp;
                    }
                }
            } catch (error) {
                console.error("Failed to fetch social links for footer:", error);
            }
        }
    },
    mounted() {
        this.fetchSocialLinks();
    }
};
</script>
<style lang="scss" scoped>
p {
    margin-bottom: 0px
}

.footer {
    background-color: #206387;
    position: relative;
    background-repeat: no-repeat;
    background-image: url('../../assets/images/footerbg.webp');
    background-size: contain;
    background-position: 10px center;
    width: 100%;
}

.footer .linkedin {
    background-color: #fff;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 0 7px;
}

a {
    text-decoration: none !important;
}

.apple,
.googlePlay {
    svg {
        flex-shrink: 0;
    }
}

.footer .application .h5,
.footer p,
.footer,
.search-input svg,
.whoWeAre a,
.customersService p,
.apps .app-text,
.footer #footer-desc p {
    color: #fff;
}

.footer-rights {
    padding: 30px 0;
}

@media screen and (max-width: 992px) {
    .footer-rights {

        padding-bottom: 63px;
    }
}

#rights a {
    color: #FFF;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 2rem;
    transition: .2s ease-in-out;

    &:hover {
        color: aqua;
        transform: translateY(-2px);
    }
}

.footer #rights p {
    &:lang(en) {
        font-weight: 400;
    }
}

.footer p {
    font-size: 1rem;
    line-height: 1.6;
    font-weight: 400;
    text-transform: capitalize;
}

.footer .application .h5 {
    font-size: 1.25rem;
    text-align: center;
    font-weight: 700;
}

.search-input {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    input {
        border: none;
        outline: none;
        padding: 11px;
        width: 100%;
        border-radius: 5px 0px 0px 5px;

        &:lang(en) {
            border-radius: 5px 0px 0px 5px;
        }

        &:lang(ar) {
            border-radius: 0px 5px 5px 0px;
        }

        &:focus+.icon svg,
        &:focus-visible+.icon svg {
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            transform: rotate(360deg);
        }

        &::-webkit-input-placeholder {
            color: rgba(105, 105, 115, 0.4);
        }

        &::-moz-placeholder {
            color: rgba(105, 105, 115, 0.4);
        }

        &:-ms-input-placeholder {
            color: rgba(105, 105, 115, 0.4);
        }

        &::-ms-input-placeholder {
            color: rgba(105, 105, 115, 0.4);
        }

        &::placeholder {
            color: rgba(105, 105, 115, 0.4);
        }
    }

    .icon {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: 18%;
        background-color: #f29012;
        border-radius: 0px 7px 7px 0px;

        &:lang(en) {
            border-radius: 0px 7px 7px 0px;
        }

        &:lang(ar) {
            border-radius: 7px 0px 0px 7px;
        }

        svg {
            -webkit-transition: all 0.4s ease-in-out;
            -o-transition: all 0.4s ease-in-out;
            transition: all 0.4s ease-in-out;
        }
    }
}

.footer .paymentMethod svg {
    margin: 0px 5px;
}

.whoWeAre p,
.customersService p {
    font-size: 1rem;
    font-weight: 400;
    margin-bottom: 13px;
    -webkit-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
}

.whoWeAre a {
    &.router-link-exact-active {
        p {
            color: #17a9e3;
            font-weight: 700;
        }
    }
}

.customersService a:hover,
.whoWeAre a:hover {
    p {
        color: antiquewhite;

        &:lang(ar) {
            -webkit-transform: translateX(-10px);
            -ms-transform: translateX(-10px);
            transform: translateX(-10px);
        }

        &:lang(en) {
            -webkit-transform: translateX(10px);
            -ms-transform: translateX(10px);
            transform: translateX(10px);
        }
    }
}

.social a svg {
    -webkit-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
}

.social a:hover {
    cursor: pointer;

    svg {
        -webkit-transform: translateY(5px) !important;
        -ms-transform: translateY(5px) !important;
        transform: translateY(5px) !important;
    }
}

.apps {
    .app-text {
        font-size: .8rem;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: 0.15px;
        white-space: nowrap;
    }

    .apple,
    .googlePlay {
        .app-text {
            font-optical-sizing: auto;
            font-weight: 400;
            margin-bottom: 0;
            font-weight: 600;
            line-height: 1.25rem;
            letter-spacing: 0.15px;
        }

        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        gap: 10px;
        border-radius: 4px;
        padding: 8px 15px;
        border: 2px solid #fff;
    }
}

.footer #footer-desc p {
    color: #FFF;
    font-size: 0.75rem;
    font-weight: 400;
}

hr {
    border: 1px solid #fff;
    margin-top: 40px;
}

.social {
    z-index: 4;
}

.cards .img-bg,
hr,
.search-input input {
    background: #fff;
}

.cards {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 24px;

    .img-bg,
    .img-bg-1,
    .img-bg-2 {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
        width: 52.5px;
        height: 35px;
    }

    .img-bg {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        border-radius: 6px;
        -webkit-box-shadow: 0px 13px 24px 0px rgba(0, 0, 0, 0.11),
            0px 5.431px 10.027px 0px rgba(0, 0, 0, 0.08),
            0px 2.904px 5.361px 0px rgba(0, 0, 0, 0.07),
            0px 1.628px 3.005px 0px rgba(0, 0, 0, 0.05),
            0px 0.865px 1.596px 0px rgba(0, 0, 0, 0.04),
            0px 0.36px 0.664px 0px rgba(0, 0, 0, 0.03);
        box-shadow: 0px 13px 24px 0px rgba(0, 0, 0, 0.11),
            0px 5.431px 10.027px 0px rgba(0, 0, 0, 0.08),
            0px 2.904px 5.361px 0px rgba(0, 0, 0, 0.07),
            0px 1.628px 3.005px 0px rgba(0, 0, 0, 0.05),
            0px 0.865px 1.596px 0px rgba(0, 0, 0, 0.04),
            0px 0.36px 0.664px 0px rgba(0, 0, 0, 0.03);

        img {
            width: 100%;
        }
    }

    .img-1,
    .img-2 {
        width: 95px;
        margin-top: 26px;
    }
}

p.desc {
    line-height: 1.9
}

.footer #rights p {
    font-size: 0.75rem;
    font-weight: 800;
}

@media screen and (max-width: 600px) {
    .footer .last {
        display: block !important;
    }
}

@media screen and (max-width: 768px) {
    hr {
        margin-top: 60px;
    }
}
</style>